<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  options: { type: Array, required: true },
  placeholder: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const open = ref(false);
const rootEl = ref(null);

function selectedLabel() {
  const found = props.options.find(o => o.value === props.modelValue);
  return found ? found.label : props.placeholder;
}

function select(value) {
  emit('update:modelValue', value);
  open.value = false;
}

function toggle() {
  open.value = !open.value;
}

function onClickOutside(e) {
  if (rootEl.value && !rootEl.value.contains(e.target)) {
    open.value = false;
  }
}

onMounted(() => document.addEventListener('mousedown', onClickOutside));
onUnmounted(() => document.removeEventListener('mousedown', onClickOutside));
</script>

<template>
  <div ref="rootEl" class="relative">
    <button
      type="button"
      class="!h-8 w-full flex items-center justify-between gap-1 border rounded-lg px-3 text-sm transition-colors focus:outline-none"
      :class="
        modelValue
          ? 'border-n-brand text-n-brand bg-n-alpha-2'
          : 'border-n-weak text-n-slate-12 bg-n-background hover:border-n-container'
      "
      @click="toggle"
    >
      <span class="truncate">{{ selectedLabel() }}</span>
      <span
        class="i-lucide-chevron-down size-3.5 flex-shrink-0 text-n-slate-10"
      />
    </button>
    <div
      v-if="open"
      class="absolute left-0 top-full mt-1 z-30 bg-n-background border border-n-weak rounded-xl shadow-xl py-1 min-w-full w-max"
      @click.stop
    >
      <button
        v-for="opt in options"
        :key="opt.value"
        type="button"
        class="w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-n-alpha-1 transition-colors focus:outline-none text-left"
        :class="
          opt.value === modelValue
            ? 'text-n-brand font-medium'
            : 'text-n-slate-12'
        "
        @click="select(opt.value)"
      >
        <span class="flex-1 truncate">{{ opt.label }}</span>
        <span
          v-if="opt.value === modelValue"
          class="i-lucide-check size-3 text-n-brand flex-shrink-0 ml-auto"
        />
      </button>
    </div>
  </div>
</template>
